define(["exports", "./utils", "./biblio", "../core/l10n", "hyperhtml", "./pubsubhub"], function (_exports, _utils, _biblio, _l10n, _hyperhtml, _pubsubhub) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.renderInlineCitation = renderInlineCitation;
  _exports.wireReference = wireReference;
  _exports.stringifyReference = stringifyReference;
  _exports.name = void 0;
  _hyperhtml = _interopRequireDefault(_hyperhtml);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject8() {
    const data = _taggedTemplateLiteral(["\n    <cite>\n      <a\n        href=\"", "\"\n        target=\"", "\"\n        rel=\"noopener noreferrer\">\n        ", "</a>.\n    </cite>\n    <span class=\"authors\">\n      ", "\n    </span>\n    <span class=\"publisher\">\n      ", "\n    </span>\n    <span class=\"pubDate\">\n      ", "\n    </span>\n    <span class=\"pubStatus\">\n      ", "\n    </span>\n  "]);

    _templateObject8 = function _templateObject8() {
      return data;
    };

    return data;
  }

  function _templateObject7() {
    const data = _taggedTemplateLiteral(["\n      <dt id=\"", "\">[", "]</dt>\n      <dd><em class=\"respec-offending-element\">Reference not found.</em></dd>\n    "]);

    _templateObject7 = function _templateObject7() {
      return data;
    };

    return data;
  }

  function _templateObject6() {
    const data = _taggedTemplateLiteral(["\n      <dt id=\"", "\">[", "]</dt>\n      <dd>", "</dd>\n    "]);

    _templateObject6 = function _templateObject6() {
      return data;
    };

    return data;
  }

  function _templateObject5() {
    const data = _taggedTemplateLiteral(["[<cite><a class=\"bibref\" href=\"", "\">", "</a></cite>]"]);

    _templateObject5 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4() {
    const data = _taggedTemplateLiteral(["\n      <dl class='bibliography'>\n        ", "\n      </dl>"]);

    _templateObject4 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3() {
    const data = _taggedTemplateLiteral(["\n      <section>\n        <h3>", "</h3>\n      </section>"]);

    _templateObject3 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2() {
    const data = _taggedTemplateLiteral(["<p>", "</p>"]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["\n    <section id='references' class='appendix'>\n      <h2>", "</h2>\n      ", "\n    </section>"]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  const name = "core/render-biblio";
  _exports.name = name;
  const localizationStrings = {
    en: {
      info_references: "Informative references",
      norm_references: "Normative references",
      references: "References"
    },
    nl: {
      info_references: "Informatieve referenties",
      norm_references: "Normatieve referenties",
      references: "Referenties"
    },
    es: {
      info_references: "Referencias informativas",
      norm_references: "Referencias normativas",
      references: "Referencias"
    }
  };
  const lang = _l10n.lang in localizationStrings ? _l10n.lang : "en";
  const l10n = localizationStrings[lang];
  const REF_STATUSES = new Map([["CR", "W3C Candidate Recommendation"], ["ED", "W3C Editor's Draft"], ["FPWD", "W3C First Public Working Draft"], ["LCWD", "W3C Last Call Working Draft"], ["NOTE", "W3C Note"], ["PER", "W3C Proposed Edited Recommendation"], ["PR", "W3C Proposed Recommendation"], ["REC", "W3C Recommendation"], ["WD", "W3C Working Draft"], ["WG-NOTE", "W3C Working Group Note"]]);
  const defaultsReference = Object.freeze({
    authors: [],
    date: "",
    href: "",
    publisher: "",
    status: "",
    title: "",
    etAl: false
  });
  const endWithDot = endNormalizer(".");

  function run(conf) {
    const informs = Array.from(conf.informativeReferences);
    const norms = Array.from(conf.normativeReferences);
    if (!informs.length && !norms.length && !conf.refNote) return;
    const refsec = (0, _hyperhtml.default)(_templateObject(), l10n.references, conf.refNote ? (0, _hyperhtml.default)(_templateObject2(), conf.refNote) : "");

    for (const type of ["Normative", "Informative"]) {
      const refs = type === "Normative" ? norms : informs;
      if (!refs.length) continue;
      const sec = (0, _hyperhtml.default)(_templateObject3(), type === "Normative" ? l10n.norm_references : l10n.info_references);
      (0, _utils.addId)(sec);
      const {
        goodRefs,
        badRefs
      } = refs.map(toRefContent).reduce((refObjects, ref) => {
        const refType = ref.refcontent ? "goodRefs" : "badRefs";
        refObjects[refType].push(ref);
        return refObjects;
      }, {
        goodRefs: [],
        badRefs: []
      });
      const uniqueRefs = [...goodRefs.reduce((uniqueRefs, ref) => {
        if (!uniqueRefs.has(ref.refcontent.id)) {
          // the condition ensures that only the first used [[TERM]]
          // shows up in #references section
          uniqueRefs.set(ref.refcontent.id, ref);
        }

        return uniqueRefs;
      }, new Map()).values()];
      const refsToShow = uniqueRefs.concat(badRefs).sort((a, b) => a.ref.toLocaleLowerCase().localeCompare(b.ref.toLocaleLowerCase()));
      sec.appendChild((0, _hyperhtml.default)(_templateObject4(), refsToShow.map(showRef)));
      refsec.appendChild(sec);
      const aliases = getAliases(goodRefs);
      decorateInlineReference(uniqueRefs, aliases);
      warnBadRefs(badRefs);
    }

    document.body.appendChild(refsec);
  }
  /**
   * returns refcontent and unique key for a reference among its aliases
   * and warns about circular references
   * @param {String} ref
   */


  function toRefContent(ref) {
    let refcontent = _biblio.biblio[ref];
    let key = ref;
    const circular = new Set([key]);

    while (refcontent && refcontent.aliasOf) {
      if (circular.has(refcontent.aliasOf)) {
        refcontent = null;
        const msg = "Circular reference in biblio DB between [`".concat(ref, "`] and [`").concat(key, "`].");
        (0, _pubsubhub.pub)("error", msg);
      } else {
        key = refcontent.aliasOf;
        refcontent = _biblio.biblio[key];
        circular.add(key);
      }
    }

    if (refcontent && !refcontent.id) {
      refcontent.id = ref.toLowerCase();
    }

    return {
      ref,
      refcontent
    };
  }
  /**
   * Render an inline citation
   *
   * @param {String} ref the inline reference.
   * @returns HTMLElement
   */


  function renderInlineCitation(ref) {
    const key = ref.replace(/^(!|\?)/, "");
    const href = "#bib-".concat(key.toLowerCase());
    return (0, _hyperhtml.default)(_templateObject5(), href, key);
  }
  /**
   * renders a reference
   */


  function showRef({
    ref,
    refcontent
  }) {
    const refId = "bib-".concat(ref.toLowerCase());

    if (refcontent) {
      return (0, _hyperhtml.default)(_templateObject6(), refId, ref, {
        html: stringifyReference(refcontent)
      });
    } else {
      return (0, _hyperhtml.default)(_templateObject7(), refId, ref);
    }
  }

  function endNormalizer(endStr) {
    return str => {
      const trimmed = str.trim();
      const result = !trimmed || trimmed.endsWith(endStr) ? trimmed : trimmed + endStr;
      return result;
    };
  }

  function wireReference(rawRef, target = "_blank") {
    if (typeof rawRef !== "object") {
      throw new TypeError("Only modern object references are allowed");
    }

    const ref = Object.assign({}, defaultsReference, rawRef);
    const authors = ref.authors.join("; ") + (ref.etAl ? " et al" : "");
    const status = REF_STATUSES.get(ref.status) || ref.status;
    return _hyperhtml.default.wire(ref)(_templateObject8(), ref.href, target, ref.title.trim(), endWithDot(authors), endWithDot(ref.publisher), endWithDot(ref.date), endWithDot(status));
  }

  function stringifyReference(ref) {
    if (typeof ref === "string") return ref;
    let output = "<cite>".concat(ref.title, "</cite>");
    output = ref.href ? "<a href=\"".concat(ref.href, "\">").concat(output, "</a>. ") : "".concat(output, ". ");

    if (ref.authors && ref.authors.length) {
      output += ref.authors.join("; ");
      if (ref.etAl) output += " et al";
      output += ". ";
    }

    if (ref.publisher) {
      output = "".concat(output, " ").concat(endWithDot(ref.publisher), " ");
    }

    if (ref.date) output += "".concat(ref.date, ". ");
    if (ref.status) output += "".concat(REF_STATUSES.get(ref.status) || ref.status, ". ");
    if (ref.href) output += "URL: <a href=\"".concat(ref.href, "\">").concat(ref.href, "</a>");
    return output;
  }
  /**
   * get aliases for a reference "key"
   */


  function getAliases(refs) {
    return refs.reduce((aliases, ref) => {
      const key = ref.refcontent.id;
      const keys = !aliases.has(key) ? aliases.set(key, []).get(key) : aliases.get(key);
      keys.push(ref.ref);
      return aliases;
    }, new Map());
  }
  /**
   * fix biblio reference URLs
   * Add title attribute to references
   */


  function decorateInlineReference(refs, aliases) {
    refs.map(({
      ref,
      refcontent
    }) => {
      const refUrl = "#bib-".concat(ref.toLowerCase());
      const selectors = aliases.get(refcontent.id).map(alias => "a.bibref[href=\"#bib-".concat(alias.toLowerCase(), "\"]")).join(",");
      const elems = document.querySelectorAll(selectors);
      return {
        refUrl,
        elems,
        refcontent
      };
    }).forEach(({
      refUrl,
      elems,
      refcontent
    }) => {
      elems.forEach(a => {
        a.setAttribute("href", refUrl);
        a.setAttribute("title", refcontent.title);
        a.dataset.linkType = "biblio";
      });
    });
  }
  /**
   * warn about bad references
   */


  function warnBadRefs(badRefs) {
    badRefs.forEach(({
      ref
    }) => {
      const badrefs = [...document.querySelectorAll("a.bibref[href=\"#bib-".concat(ref.toLowerCase(), "\"]"))].filter(({
        textContent: t
      }) => t.toLowerCase() === ref.toLowerCase());
      const msg = "Bad reference: [`".concat(ref, "`] (appears ").concat(badrefs.length, " times)");
      (0, _pubsubhub.pub)("error", msg);
      console.warn("Bad references: ", badrefs);
    });
  }
});
//# sourceMappingURL=render-biblio.js.map